import { render, staticRenderFns } from "./OrdersCreateAlt.vue?vue&type=template&id=8cbf5adc&"
import script from "./OrdersCreateAlt.vue?vue&type=script&lang=js&"
export * from "./OrdersCreateAlt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports